
import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent  {

    @Input() title = ''

    @Input() stepheight: boolean = false;

    @Input() steps = [];
    @Input() page = '';
    @Input() transparent = false

}
